import Vue from 'vue';
import batchIngredienceTransformer from '../../transformers/batchIngredience';
import store from '../../store';

const success = (resolve, response) => {
  store.dispatch('updateBatchIngredience', {
    batchIngredience: batchIngredienceTransformer.fetch(response.data),
    id: response.data.id,
  });
  resolve();
};

const failed = (errors, reject) => {
  reject(errors);
};

export default (id, data) => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post(`/production/batch_ingredience/${id}/deduct`, data)
      .then((response) => {
        success(resolve, response);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/batchIngredience/deduct.js